export default {
  init() {
    // JavaScript to be fired on all pages
    $('[data-slick]').slick({
      'prevArrow' : '<button type="button" class="slick-prev"><i class="fas fa-caret-left"></i></button>', 
      'nextArrow' : '<button type="button" class="slick-next"><i class="fas fa-caret-right"></i></button>',
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js